import React from 'react';

const Library = () => {
  return <>Library</>;
};

export default Library;
